import { Flex } from '@rebass/emotion';
import { GetProductsForFinder_getProducts_result_items_price_main as PriceProps } from '../ProductsProvider/__generated__/GetProductsForFinder';
import { Wrapper, Price, PriceDiff } from './styles';
import ProductLicense from '../ProductLicense';

export const PriceBox = ({
  itemType,
  license,
  licenseId,
  originalPrice,
  minPrice,
  personalized,
}: DeepOmit<PriceProps, '__typename'>): JSX.Element => {
  return (
    <Wrapper>
      {minPrice && minPrice !== originalPrice && (
        <PriceDiff
          data-testid="product-tile-diff-price"
          className="product-tile-diff-price"
        >
          {originalPrice}
        </PriceDiff>
      )}

      <Flex alignItems="center" justifyContent="center" flexDirection="column">
        <Price>
          <span
            data-testid="product-tile-price"
            className="product-tile-original-price"
          >
            {minPrice || originalPrice}
          </span>
        </Price>

        <ProductLicense
          itemType={itemType}
          license={license}
          licenseId={licenseId}
          personalized={personalized}
        />
      </Flex>
    </Wrapper>
  );
};

export default PriceBox;
